module.exports = require('react/lib/ReactCSSTransitionGroup');


/*****************
 ** WEBPACK FOOTER
 ** /usr/src/sentry/~/react-addons-css-transition-group/index.js
 ** module id = 738
 ** module chunks = 1
 **/